/**
 * Shared add-to-cart helper for LH landing sections.
 * Adds via /cart/add.js, renders the cart drawer, and opens it.
 */
function lhLandingsAddToCart(form, submitButton) {
  if (!form) return Promise.resolve();

  const originalText = submitButton ? submitButton.textContent.trim() : '';
  const cartDrawer = document.querySelector('cart-drawer');

  if (submitButton) {
    submitButton.textContent = window.lhLandingsStrings?.adding || 'ADDING...';
    submitButton.disabled = true;
  }

  const formData = new FormData(form);
  if (cartDrawer) {
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
  }

  return fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/javascript',
    },
    body: formData,
  })
    .then((response) => response.json())
    .then((parsedState) => {
      if (parsedState.status) {
        throw new Error(parsedState.description || parsedState.message);
      }

      if (!cartDrawer) {
        window.location.href = window.routes?.cart_url || '/cart';
        return;
      }

      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(parsedState);

      if (submitButton) {
        submitButton.textContent = window.lhLandingsStrings?.added || 'ADDED';
      }

      setTimeout(() => {
        if (submitButton) {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      }, 2000);
    })
    .catch((error) => {
      console.error('LH add to cart error:', error);
      if (submitButton) {
        submitButton.textContent = window.lhLandingsStrings?.error || 'ERROR';
        submitButton.disabled = false;
      }
    });
}

window.lhLandingsAddToCart = lhLandingsAddToCart;
